import React from "react"
import "./index.scss"
import { CompaniesIcons } from "./subcomponents/IconsCompanies"
import Clutch2019Icon from "../../components/icons/Clutch2019"
import Clutch2020Icon from "../../components/icons/Clutch2020"
import Clutch2021Icon from "../../components/icons/Clutch2021"


export const HomeIcons = () => {
    return (
        <div className="icons">
            <CompaniesIcons/>
            <div className="icons-clutch">
                <Clutch2019Icon width="90px" height="100px"/>
                <Clutch2020Icon width="90px" height="100px"/>
                <Clutch2021Icon width="90px" height="100px"/>
            </div>
        </div>
    )
}
